var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartRecording(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 43.2v9.6c0 1.326 1.069 2.4 2.389 2.4a2.394 2.394 0 0 0 2.389-2.4v-9.6c0-1.326-1.07-2.4-2.39-2.4A2.394 2.394 0 0 0 26 43.2zM37.944 60a2.394 2.394 0 0 0 2.39-2.4V38.4c0-1.326-1.07-2.4-2.39-2.4a2.394 2.394 0 0 0-2.388 2.4v19.2c0 1.326 1.069 2.4 2.388 2.4zm11.945-9.6v-4.8c0-1.326-1.07-2.4-2.389-2.4a2.394 2.394 0 0 0-2.389 2.4v4.8c0 1.326 1.07 2.4 2.389 2.4a2.394 2.394 0 0 0 2.389-2.4zM69 52.8v-9.6c0-1.326-1.069-2.4-2.389-2.4a2.394 2.394 0 0 0-2.389 2.4v9.6c0 1.326 1.07 2.4 2.39 2.4A2.394 2.394 0 0 0 69 52.8zm-9.556 2.4V40.8c0-1.326-1.069-2.4-2.388-2.4a2.394 2.394 0 0 0-2.39 2.4v14.4c0 1.326 1.07 2.4 2.39 2.4a2.394 2.394 0 0 0 2.388-2.4z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartRecording);
export default __webpack_public_path__ + "static/media/start_recording.731d9b64b4a220d640c312bf4006b04e.svg";
export { ForwardRef as ReactComponent };